import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { QuotesProductListSearch } from '../../../../core/quotes.model';
import { initialStatus } from '../../../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class QuoteProductListService {
  protected searchProductList$ = new BehaviorSubject<QuotesProductListSearch>(initialStatus);

  showProducts$ = new BehaviorSubject(false);
  currentQuery = '';

  getSearchResult() {
    return this.searchProductList$.asObservable();
  }

  setSearchResult(response: QuotesProductListSearch) {
    this.searchProductList$.next(response);
  }

  resetList() {
    this.searchProductList$.next(initialStatus);
    this.currentQuery = '';
  }
}
